module.exports = __webpack_public_path__ + "static/media/zip-payments.2feca4b5.svg";